"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var v5_exports = {};
__export(v5_exports, {
  createThemes: () => import_theme_builder.createThemes,
  themes: () => import_generated_v5.themes,
  tokens: () => import_v5_tokens.tokens,
  v5Templates: () => import_v5_templates.v5Templates
});
module.exports = __toCommonJS(v5_exports);
var import_theme_builder = require("@tamagui/theme-builder");
var import_generated_v5 = require("./generated-v5");
var import_v5_templates = require("./v5-templates");
__reExport(v5_exports, require("./v5-themes"), module.exports);
var import_v5_tokens = require("./v5-tokens");
//# sourceMappingURL=v5.js.map
